import React, { useCallback } from 'react';
import Constant from '@/common/constant/Constant';
import { MenuItem, TextField, ListSubheader, Tooltip } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function TelephonePublisherFilter(props) {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const {
        filterTelephonePublisher,
        setFilterTelephonePublisher,
        helpDeskList,
        helpDeskListInView
    } = props;

    // Use useCallback to prevent re-creation on every render
    const handleOnChangeFilterTelephonePublisher = useCallback((event) => {
        const value = event.target.value === Constant.QA_FILTER_CREATOR.ALL 
            ? '' 
            : event.target.value;
        setFilterTelephonePublisher(value);
    }, [setFilterTelephonePublisher]);

    const internalHelpDeskList = helpDeskList.filter(
        (item) => item.helpDeskType === Constant.HELPDESK_LIST_TYPE.INTERNAL
    );
    const externalHelpDeskList = helpDeskList.filter(
        (item) => item.helpDeskType === Constant.HELPDESK_LIST_TYPE.EXTERNAL
    );

    const helpDeskIdList = helpDeskListInView;
    const internalHelpDeskTelephoneList =
        helpDeskIdList && helpDeskIdList.length
            ? internalHelpDeskList.filter(helpDesk => helpDeskIdList.includes(helpDesk.id))
            : [];
    const externalHelpDeskTelephoneList =
        helpDeskIdList && helpDeskIdList.length
            ? externalHelpDeskList.filter(helpDesk => helpDeskIdList.includes(helpDesk.id))
            : [];

    return (
        <div className="qa-filter-wrap" data-cy="ticket-list-filter">
            <div className="qa-filter-group" data-cy="filter-field-frame">
                <label className="filter-label" data-cy="filter-status-title">
                    {trI18n('CM-LABEL-FILTER-PUBLISHER')}
                </label>
                <div className="filter-input" data-cy="filter-status-selectbox">
                    <TextField
                        className="form-control form-control--wrap form-control--hg32"
                        select
                        variant="outlined"
                        value={
                            filterTelephonePublisher
                                ? filterTelephonePublisher
                                : Constant.QA_FILTER_CREATOR.ALL
                        }
                        onChange={handleOnChangeFilterTelephonePublisher}
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null,
                                className: 'selectDrop'
                            }
                        }}
                    >
                        <MenuItem value={Constant.QA_FILTER_CREATOR.ALL}>
                            {trI18n('CM-LABEL-FILTER-ALL')}
                        </MenuItem>
                        <MenuItem value={Constant.QA_FILTER_CREATOR.ME}>
                            {trI18n('CM-LABEL-FILTER-ME')}
                        </MenuItem>
                        {!Utils.isEmptyArray(internalHelpDeskTelephoneList) && (
                            <ListSubheader
                                className="list-sub-header"
                                color="inherit"
                                disableSticky
                                onClickCapture={e => e.stopPropagation()}
                            >
                                {trI18n('CM-LABEL-INTERNAL-PRJ')}
                            </ListSubheader>
                        )}
                        {internalHelpDeskTelephoneList?.map(
                            helpDesk =>
                                helpDeskIdList.includes(helpDesk.id) && (
                                    <Tooltip
                                        key={helpDesk.id}
                                        value={helpDesk.id}
                                        title={helpDesk.shortName}
                                        placement="top"
                                        arrow
                                        interactive
                                    >
                                        <MenuItem
                                            value={helpDesk.id}
                                            className="filter-menu-item"
                                        >
                                            <div className="filter-helpDesk-item">
                                                {helpDesk.shortName}
                                            </div>
                                        </MenuItem>
                                    </Tooltip>
                                )
                        )}
                        {!Utils.isEmptyArray(externalHelpDeskTelephoneList) && (
                            <ListSubheader
                                className="list-sub-header"
                                color="inherit"
                                disableSticky
                                onClickCapture={e => e.stopPropagation()}
                            >
                                {trI18n('CM-LABEL-EXTERNAL-PRJ')}
                            </ListSubheader>
                        )}
                        {externalHelpDeskTelephoneList?.map(
                            helpDesk =>
                                helpDeskIdList.includes(helpDesk.id) && (
                                    <Tooltip
                                        key={helpDesk.id}
                                        value={helpDesk.id}
                                        title={helpDesk.displayName}
                                        placement="top"
                                        arrow
                                        interactive
                                    >
                                        <MenuItem
                                            value={helpDesk.id}
                                            className="filter-menu-item"
                                        >
                                            <div className="filter-helpDesk-item">
                                                {helpDesk.displayName}
                                            </div>
                                        </MenuItem>
                                    </Tooltip>
                                )
                        )}
                    </TextField>
                </div>
            </div>
        </div>
    );
}
